import React from "react";
import Loader from "react-loader-spinner";
import PropTypes from "prop-types";
import FGVLogo from "assets/img/fgv-logo.png";
import { Typography } from "@material-ui/core";

const LoadingIcon = (props) => {
  const {
    type,
    color,
    height,
    width,
    image,
    text,
    imageDimension,
    secondaryColor,
    ...rest
  } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px",
      }}
    >
      {image ? <img src={FGVLogo} alt="FGV" width={imageDimension} /> : null}
      <Loader
        type={type}
        color={color}
        height={height}
        width={width}
        secondaryColor={secondaryColor}
        {...rest}
      />
      <Typography color="textPrimary" variant="h4">
        {text.length ? text : null}
      </Typography>
    </div>
  );
};

LoadingIcon.propTypes = {
  prop: PropTypes.object,
  type: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  image: PropTypes.bool,
  text: PropTypes.string,
  imageDimension: PropTypes.number,
  secondaryColor: PropTypes.string,
};

LoadingIcon.defaultProps = {
  type: "MutatingDots",
  color: "#ed1c24",
  height: 100,
  width: 100,
  image: false,
  text: "",
  imageDimension: 200,
  secondaryColor: "#f7941e",
};

export default LoadingIcon;
